module.exports = __webpack_public_path__ + "static/media/success.acacc443.svg";